export type ProviderName = 'Google Workspace' | 'Microsoft 365' | 'LinkedIn';

export function providerLabel(provider: string): ProviderName {
  return provider === 'microsoft_365'
    ? 'Microsoft 365'
    : provider === 'linkedin'
      ? 'LinkedIn'
      : 'Google Workspace';
}

/** The `provider` a connect (or reconnect) request sends for this account. */
export function providerParam(
  provider: string
): 'google' | 'microsoft' | 'linkedin' {
  return provider === 'microsoft_365'
    ? 'microsoft'
    : provider === 'linkedin'
      ? 'linkedin'
      : 'google';
}
